/* eslint-disable sort-keys-fix/sort-keys-fix -- CSS-in-JS pseudo-selector keys use semantic ordering */
// MUI v4 TableCell — NS/Tractie component overrides.
// All MUI v4 style classes are declared explicitly (no implicit inheritance on MUI defaults).
// Tractie deviation: borderBottom via NS border-default token (mode-aware) i.p.v.
// MUI default lighten/darken on alpha(divider). Cell text color via NS fg-default
// (head/body) en fg-subtle (footer). padding 16 (Tractie inset-m, conform Card).

export const MuiTableCellLightOverrides = {
  root: {
    display: 'table-cell' as const,
    verticalAlign: 'inherit' as const,
    borderBottom: '1px solid var(--ns-color-border-default)',
    textAlign: 'left' as const,
    padding: 16,
    color: 'var(--ns-color-fg-default)',
    fontSize: '0.875rem',
    lineHeight: 1.43,
    letterSpacing: 'normal',
  },

  head: {
    color: 'var(--ns-color-fg-default)',
    lineHeight: '1.5rem',
    fontWeight: 600,
  },

  body: {
    color: 'var(--ns-color-fg-default)',
  },

  footer: {
    color: 'var(--ns-color-fg-subtle)',
    lineHeight: '1.3125rem',
    fontSize: '0.75rem',
  },

  sizeSmall: {
    padding: '6px 24px 6px 16px',
    '&:last-child': {
      paddingRight: 16,
    },
    '&$paddingCheckbox': {
      width: 24,
      padding: '0 12px 0 16px',
      '&:last-child': {
        paddingLeft: 12,
        paddingRight: 16,
      },
    },
  },

  paddingCheckbox: {
    width: 48,
    padding: '0 0 0 4px',
    '&:last-child': {
      paddingLeft: 0,
      paddingRight: 4,
    },
  },

  paddingNone: {
    padding: 0,
    '&:last-child': {
      padding: 0,
    },
  },

  alignLeft: {
    textAlign: 'left' as const,
  },

  alignCenter: {
    textAlign: 'center' as const,
  },

  alignRight: {
    textAlign: 'right' as const,
    flexDirection: 'row-reverse' as const,
  },

  alignJustify: {
    textAlign: 'justify' as const,
  },

  stickyHeader: {
    position: 'sticky' as const,
    top: 0,
    zIndex: 2,
    backgroundColor: 'var(--ns-color-bg-default)',
  },
} as const;

// Dark variant — alle kleur-tokens zijn mode-aware via tokens.css.
export const MuiTableCellDarkOverrides = {
  ...MuiTableCellLightOverrides,
} as const;
